<template>
  <div
    class="b-nav-bar"
    :class="navBarClass"
    :style="navBarStyle"
  >
    <div
      class="b-nav-bar__panel"
      :style="navBarPanelStyle"
    >
      <slot name="left">
        <transition
          name="fade"
          mode="out-in"
          :duration="150"
        >
          <div
            v-if="isMenuOpened"
            key="city-selector"
            class="b-nav-bar__city-selector"
          >
            <CitySelectorV2 @click="isShowSelectCityModal = true">
              <template #icon>
                <div class="b-nav-bar__icon b-nav-bar__city-selector-icon">
                  <sprite
                    src="sprites_city-selector"
                    class="b-nav-bar__icon-sprite b-nav-bar__icon-sprite--stroke"
                  />
                </div>
              </template>
            </CitySelectorV2>
          </div>
          <div
            v-else
            key="logo"
            class="b-nav-bar__logo"
          >
            <sprite
              class="b-nav-bar__logo-svg"
              :style="logoColorStyle"
              src="sprites_logo-one-line_simple"
            />
          </div>
        </transition>
      </slot>

      <div class="b-nav-bar__panel-title">
        <slot name="title" />
      </div>
      <div
        v-if="!hideBtns"
        class="b-nav-bar__panel-btns"
      >
        <slot name="right">
          <div
            v-if="showLk"
            class="b-nav-bar__panel-btns-item b-nav-bar__panel-btns-item--lk"
            @click="profileClick()"
          >
            <div class="b-nav-bar__icon">
              <sprite
                class="b-nav-bar__icon-sprite"
                :class="navBarIconClass"
                src="sprites_icon-user"
              />
            </div>
          </div>
          <div
            class="b-nav-bar__panel-btns-item b-nav-bar__panel-btns-item--cross"
            @click="isMenuOpened = !isMenuOpened"
          >
            <div
              class="b-nav-bar__panel-menu-icon"
              :class="menuIconClass"
            >
              <span />
              <span />
              <span />
            </div>
          </div>
        </slot>
      </div>
    </div>

    <transition name="fade-top">
      <div
        v-show="isMenuOpened"
        class="b-nav-bar__menu"
      >
        <div class="b-nav-bar__menu-hr" />
        <div class="b-nav-bar__menu-content">
          <div
            v-if="isGoalsBlockVisible"
            class="b-nav-bar__menu-slider"
          >
            <div class="b-nav-bar__menu-title">
              Выберите свою цель
            </div>
            <div class="menu-slider__wrapper">
              <swiper
                ref="menuSlider"
                class="menu-slider"
                slides-per-view="auto"
                :space-between="16"
                :autoplay="{
                  'delay': 3000,
                  'disableOnInteraction': true,
                }"
                @swiper="setSwiper"
              >
                <swiper-slide
                  v-for="(item, index) in appBarDataMap"
                  :key="'menu-slider'+index"
                  class="menu-slide"
                  @click="clickTarget(item)"
                >
                  <router-link
                    class="menu-slide__link"
                    :to="item.AppBarTargetLink"
                    @click="isMenuOpened = false"
                  >
                    <div class="menu-slide__img">
                      <Image
                        :src="item.AppBarTargetImage"
                        :alt="item.title"
                      />
                    </div>
                    <div
                      class="menu-slide__title"
                      :style="{color: item.AppBarTargetColor }"
                    >
                      {{ item.AppBarTargetTitle }}
                    </div>
                    <div
                      class="menu-slide__desc"
                      :style="getDescriptionStyles(item)"
                      v-html="item.AppBarTargetSubtitle"
                    />
                  </router-link>
                </swiper-slide>
              </swiper>
            </div>
          </div>
          <nav class="b-nav-bar__menu-links">
            <component
              :is="navLink.tag"
              v-for="(navLink, navKey) in navBarMenuLinks"
              :key="`nav-bar-menu-link-${navKey}`"
              class="b-nav-bar__menu-link"
              :class="[navLink.subClass]"
              :href="navLink.link"
              :to="navLink.link"
              :target="navLink.target || null"
              @click="onClickNavLink(), navLink.click()"
            >
              {{ navLink.text }}
            </component>
          </nav>
        </div>
      </div>
    </transition>
    <ModalWindow
      v-if="showCityBtn"
      v-model:value="isShowSelectCityModal"
      class="city-modal__wrapper"
      class-name="city-modal"
      transition-name="fade-top"
    >
      <CityModalV2
        @onChangeVcp="onChangeVcp"
        @close="isShowSelectCityModal=false"
      />
    </ModalWindow>
  </div>
</template>

<script>
import api from '@/api'

import Cookies from '@/services/cookies'
import { inject } from 'vue'
// ui
import ModalWindow from '@/components/core/ui/modal/ModalWindow'
// components
import CitySelectorV2 from '@/components/core/lib/CitySelectorV2.vue'
import CityModalV2 from '@/components/core/lib/CityModalV2.vue'
// other
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { openModalScroll, closeModalScroll } from '@/services/modal'

import { mapVCP } from '@/services/mapVCP'

import { Swiper, SwiperSlide } from 'swiper/swiper-vue'
import { WELCOME_SET_PATH } from '@/config/constants'

export default {
  name: 'AppHeaderV2',
  components: {
    ModalWindow,
    CitySelectorV2,
    CityModalV2,
    Swiper,
    SwiperSlide,
  },
  props: {
    showLk: {
      type: Boolean,
      default: true,
    },
    showCityBtn: {
      type: Boolean,
      default: true,
    },
    hideBtns: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    disableSticky: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onChangeVcp'],
  setup () {
    const pricePlanId = inject('pricePlanId', null)
    const menuDays = inject('menuDays', 6)

    const openForSuppliersModal = inject('openForSuppliersModal')

    return {
      pricePlanId,
      menuDays,
      openForSuppliersModal,
    }
  },
  data () {
    return {
      isGoalsBlockVisible: false, // TODO: Get flag from VCP in future
      mount: false,
      isMenuOpened: false,
      isShowSelectCityModal: false,
      lastScrollPos: 0,
      hide: false,
      isOnTop: true,
      mySwiper: null,
      navBarMenuLinks: [
        {
          text: 'Наше меню',
          subClass: '',
          link: '#our-menu',
          click: () => {
            this.$router.push('/new-order-tariff')
          },
          tag: 'router-link',
        },
        {
          text: 'Вопросы и ответы',
          subClass: '',
          link: '#faq',
          click: () => {},
          tag: 'router-link',
        },
        {
          text: 'Скачать приложение',
          subClass: '',
          link: '#mob-app',
          click: () => {},
          tag: 'router-link',
        },
        {
          text: 'Контакты',
          subClass: '',
          link: '#contacts',
          click: () => {},
          tag: 'router-link',
        },
        {
          text: 'Качество еды',
          subClass: '',
          link: 'https://quality.growfood.pro/',
          click: () => {},
          tag: 'a',
        },
        {
          text: 'Поставщикам',
          subClass: '',
          click: () => {
            this.openForSuppliersModal()
          },
          tag: 'button',
        },
        {
          text: 'Вендинги',
          subClass: '',
          link: 'https://franchise.growfood.pro/vending',
          click: () => {},
          tag: 'a',
          target: '_blank',
        },
      ],
    }
  },
  computed: {
    ...mapVCP({
      appBarP1: 'NewLandingVisual/AppBar/AppBarP1',
      appBarP2: 'NewLandingVisual/AppBar/AppBarP2',
      appBarP3: 'NewLandingVisual/AppBar/AppBarP3',
      appBarP4: 'NewLandingVisual/AppBar/AppBarP4', // на всякий случай
      appBarOptions: 'NewLandingVisual/SimpleMainHeader/SimpleMainHeaderAppBar',
      welcomeSetData: 'NewLandingVisual/WelcomeSet',
    }),
    ...mapGetters({
      isLoggedIn: 'client/isLoggedIn',
      phone: 'signin/phone',
      zIndex: 'appBar/zIndex',
      isWelcomeSetVisible: 'marketing/isWelcomeSetVisible',
    }),

    appBarDataMap () {
      const arr = []
      // TODO: костыль под нодовский вцп, попросить переделать, как будет время
      if (this.appBarP1) arr.push(this.appBarP1)
      if (this.appBarP2) arr.push(this.appBarP2)
      if (this.appBarP3) arr.push(this.appBarP3)
      if (this.appBarP4) arr.push(this.appBarP4)

      if (this.isWelcomeSetVisible && this.welcomeSetData?.active) {
        arr.push({
          AppBarTargetColor: this.welcomeSetData?.hamburgerTitleColor || '',
          AppBarTargetImage: this.welcomeSetData?.hamburgerBannerImage || '',
          AppBarTargetLink: `${WELCOME_SET_PATH}?ref=menu-goals`,
          AppBarTargetSubtitle: this.welcomeSetData?.hamburgerText || '',
          AppBarTargetTitle: this.welcomeSetData?.hamburgerTitle || '',
          isWelcomeSet: true,
        })
      }
      return arr
    },
    logoColorStyle () {
      const color = this.appBarOptions?.logoColor
      return {
        color,
      }
    },
    iconsIsWhite () {
      return this.appBarOptions?.iconsIsWhite && !this.isMenuOpened
    },
    navBarClass () {
      return {
        'b-nav-bar--hide': this.hide && !this.isMenuOpened,
        'b-nav-bar--disable-sticky': this.disableSticky,
        'b-nav-bar--shadow': this.shadow,
        'b-nav-bar--opened': this.isMenuOpened,
      }
    },
    navBarStyle () {
      return {
        'z-index': this.zIndex,
      }
    },
    navBarPanelStyle () {
      const background = this.appBarOptions?.background
      if (this.isMenuOpened || !background || this.$route.name !== 'Landing') return {}
      return {
        background,
      }
    },
    navBarIconClass () {
      return {
        'b-nav-bar__icon-sprite_white': this.iconsIsWhite,
      }
    },
    menuIconClass () {
      return {
        'b-nav-bar__panel-menu-icon_close': this.isMenuOpened,
        'b-nav-bar__panel-menu-icon_white': this.iconsIsWhite,
      }
    },
  },
  watch: {
    isMenuOpened (val) {
      if (val) {
        openModalScroll()
        setTimeout(() => {
          this.mySwiper.update()
          this.mySwiper.slideTo(0, 0, 100)
        }, 300)
      } else {
        closeModalScroll()
      }
    },
    isShowSelectCityModal (val) {
      if (val) {
        openModalScroll()
      } else {
        if (!this.isMenuOpened) {
          closeModalScroll()
        }
      }
    },
  },
  beforeMount () {
  },
  mounted () {
    this.mount = true
    if (!this.disableSticky) {
      this.initScroll()
    }
    this.isShowSelectCityModal = !Cookies.get('city_confirmed')
  },
  beforeUnmount () {
  },
  methods: {
    ...mapMutations({
      openModal: 'modals/openModal',
    }),
    ...mapActions({
      singleEvent: 'analytics/singleEvent',
      getAndSetMenuGoals: 'goals/getAndSetMenuGoals',
    }),
    getDescriptionStyles (item) {
      const styles = {}
      const textColor = this.welcomeSetData?.hamburgerTextColor
      if (item.isWelcomeSet && textColor) {
        styles.descriptionColor = textColor
      }
      return styles
    },
    clickTarget () {
      this.singleEvent('select_target')
    },
    onChangeVcp (data) {
      this.$emit('onChangeVcp', data)
    },
    onClickNavLink () {
      this.isMenuOpened = false
    },
    profileClick () {
      this.isMenuOpened = false
      if (this.isLoggedIn) {
        if (api.REDIRECT_TO_OLD_SITE_URL()) {
          api.redirectToOldSite({ path: '/new-dashboard/orders' })
        } else {
          this.$router.push('/new-dashboard/orders')
        }
      } else {
        if (this.phone) {
          this.openModal({
            name: 'EnterSms',
            params: {
              phone: this.phone,
              afterLogIn: (callback) => {
                this.getAndSetMenuGoals()
                if (callback) {
                  callback()
                }
              },
            },
          })
        } else {
          this.openModal({
            name: 'EnterPhone',
            menuDays: this.menuDays,
            pricePlanId: this.pricePlanId,
            params: {
              phone: this.phone,
              afterLogIn: (callback) => {
                this.getAndSetMenuGoals()
                if (callback) {
                  callback()
                }
              },
            },
          })
        }
      }
    },
    initScroll () {
      this.lastScrollPos = 10
      window.addEventListener('scroll', () => {
        if (!this.isMenuOpened) {
          const st = window.pageYOffset
          if (st > 56) {
            this.isOnTop = false
            this.hide = st > this.lastScrollPos
          } else {
            this.isOnTop = true
            this.hide = false
          }
          this.lastScrollPos = st
        }
      })
    },
    hideNavBar () {
      this.hide = true
    },
    setSwiper (swiper) {
      this.mySwiper = swiper
    },
    /**
     * @description Этот метод дёргается из миксина blockView
     */
    processBlockView () {
      this.sendGTMMarkupEvent({
        block: 'AppHeaderV2',
        element: 'Block',
        action: 'View',
        details: '',
      })
    },
  },
}
</script>

<style lang="scss">
  .b-nav-bar {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    z-index: 110;
    transition: transform .25s linear;

    &--opened {
      bottom: 0;
    }
    &--dark {
      color: map-get($colors, 'white');
      .b-nav-bar {
        &__panel {
          background: #000;
        }
        &__icon-sprite {
          fill: map-get($colors, 'white') !important;
        }
        &__logo-svg {
          fill: map-get($colors, 'white') !important;
        }
      }
    }

    &--disable-sticky {
      position: relative;
    }
    &--hide {
      transform: translateY(-100%);
    }
    &--shadow {
      box-shadow: 0px 0.04rem .16rem rgba(0, 0, 0, 0.05);
    }
    &--mob-app {
      top: .73rem;
    }
    &--transparent {
      .b-nav-bar {
        &__panel {
          background: transparent;
        }
      }
    }
    &__panel {
      position: relative;
      z-index: 10;
      display: flex;
      align-items: center;
      width: 100%;
      padding: .16rem .12rem; // из-за увеличения области тапов для иконок
      transition: background .3s;
      background: map-get($colors, 'white');
      &-title {
        font-weight: 600;
        font-size: 0.16rem;
        line-height: 0.24rem;
      }
      &-btns {
        margin: -0.04rem;
        margin-left: auto;
        display: flex;
        &-item {
          padding: 0.04rem;
          border: unset;
          background: unset;
          cursor: pointer;

          &--cross {
            padding: 0.04rem 0.12rem 0.04rem 0.07rem;
          }
          &--lk {
            padding: 0.04rem 0.03rem;
          }
          &:not(:first-child) {
            margin-left: .11rem;
          }
        }
        &--left {
          margin-left: unset;
          margin-right: auto;
          .b-nav-bar__panel-btns{
            &-item {
              padding: 0.04rem;
              border: unset;
              background: unset;
              &:not(:first-child) {
                margin-right: .16rem;
              }
            }
          }
        }
      }
    }
    &__logo-svg {
      display: block;
      height: .22rem;
      width: .82rem;
      padding: .01rem;
      color: map-get($colors, 'green');
      transition: color .3s;
    }
    &__city-selector {
      position: relative;
      display: flex;
      align-items: center;
      &-icon {
        margin-right: .06rem;
      }
      .dropdown-menu {
        top: 100%;
        width: 100vw;
      }
    }
    &__icon-sprite {
      display: block;
      fill: transparent !important;
      stroke: #000;
      width: 100%;
      height: 100%;
      &_white {
        stroke: #ffffff;
      }
      &--stroke {
        fill: #000 !important;
        stroke: transparent;
      }
    }
    &__icon {
      width: .24rem;
      height: .24rem;
    }
    &__panel-menu {
      &-icon {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: .24rem;
        height: .24rem;
        transition: transform .3s ease-in-out;
        span {
          position: absolute;
          background: #000;
          width: 0.18rem;
          height: 0.02rem;
          border-radius: 0.02rem;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          &:nth-child(1) {
            transform: translate3d(-50%, calc(-50% - .05rem), 0) scaleX(0.88);
            transition: transform .3s;
          }
          &:nth-child(2) {
            transform: translate3d(calc(-50% + .04rem), -50%, 0);
            width: 0.08rem;
            transition: opacity .3s;
          }
          &:nth-child(3) {
            transform: translate3d(calc(-50% + .02rem), calc(-50% + .05rem), 0) scaleX(0.66);
            transition: transform .3s;
          }
        }
        &_white {
          span {
            background: #ffffff;
          }
        }
        &_close {
          transform: rotate(180deg);
          span {
            &:nth-child(1) {
              transform: translate3d(-50%, calc(-50% - .0rem),  0) rotate(45deg);
            }
            &:nth-child(2) {
              opacity: 0;
            }
            &:nth-child(3) {
              transform: translate3d(-50%, calc(-50% + .0rem), 0) rotate(-45deg);
            }
          }
        }
      }
    }
    &__menu {
      position: relative;
      width: 100%;
      background: map-get($colors, 'white');
      overflow: auto;
      overflow-x: visible;
      &-hr {
        position: fixed;
        top: .56rem;
        left: 0;
        width: calc(100% - .32rem);
        margin: 0 .16rem;
        height: 1px;
        background: #F0F0F0;
      }
      &-content {
        margin: 0 .16rem;
      }
      &-title {
        margin-top: .23rem;
        margin-bottom: .2rem;
        font-weight: 600;
        font-size: .30rem;
        line-height: .36rem;
        color: map-get($colors, 'black');
      }
      &-slider {
        padding-bottom: .32rem;
        border-bottom: 1px solid #F0F0F0;
      }
      &-links {
        display: flex;
        flex-direction: column;
        padding: .32rem 0;
        font-weight: normal;
      }
      &-link {
        margin-bottom: .18rem;
        font-size: .20rem;
        line-height: .24rem;
        color: map-get($colors, 'black');
        border: none;
        outline: none;
        background: transparent;
        text-align: left;
        font-weight: 600;
      }
    }
  }
  .b-nav-goals-selector {
    display: flex;
    justify-content: center;
    padding: 0 .12rem;
    &__item {
      position: relative;
      color: map-get($colors, 'gray_60');
      transition: color .3s;
      &:after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        height: .04rem;
        width: .4rem;
        transform: translateX(-50%);
        border-radius: .02rem;
        background-color: transparent;
        transition: background-color .3s;
      }
      &--active {
        color: map-get($colors, 'black');
        &:after {
          background-color: map-get($colors, 'default');
        }
      }
      &:not(:last-child) {
        margin-right: .32rem;
      }
    }
  }

  .menu-slider {
    overflow: visible !important;
    &__wrapper {
      overflow: hidden !important;
      margin: 0 -.16rem !important;
      padding: 0 .16rem !important;
      // margin: 0 -.16rem;
      // padding: 0 .16rem;
    }
  }
  .menu-slide {
    width: 208px !important;

    &__link {
      display: block;
    }
    &__img {
      display: flex;
      overflow: hidden;
      margin-bottom: 16px;
      border-radius: 16px;
      img {
        width: 100%;
      }
    }
    &__title {
      margin-bottom: 8px;
      font-size: 24px;
      line-height: 1.2;
      font-weight: bold;
    }
    &__desc {
      font-weight: 400;
      text-align: left;
      font-size: 14px;
      line-height: 20px;
      color: map-get($colors, 'grey_67');
    }

    &__old-welcome-price {
      opacity: 0.5;
      text-decoration: line-through;
    }
  }
</style>
